import { MultiplierAct as BaseMultiplierAct } from "onearm";

/**
 * @description Fix for MultiplierAct.skip() NaN.
 * onearm читает this.result.winBeforeMultiplier/multiplier (неверный путь; реально
 * result.win.beforeMultiplier), из-за чего finalWin = undefined * multiplier = NaN.
 * Финальное значение спина = result.win.total (после множителя). Корректно и для базовой игры.
 */
export class MultiplierAct extends BaseMultiplierAct {
    skip() {
        this.hud.setWin(this.result.win.total);
        this.finalizeTumbleWin(this.result.win.total);
        this.reelsScene.goToIdle();
    }
}
